module.exports = __webpack_public_path__ + "img/improvement.ca8d9359.svg";